import { Injectable } from '@angular/core';

import { Observable, throwError, timer } from 'rxjs';
import { concatMap, retryWhen } from 'rxjs/operators';

import { ApiResponse } from '@core/types';

import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class LeadContactsService {
  constructor(private apiService: ApiService) {}

  find(enquirer): Observable<ApiResponse> {
    return this.apiService.post('/lead-contacts/find', enquirer).pipe(
      retryWhen(errors =>
        errors.pipe(
          concatMap((error, i) => {
            if (i >= 5) {
              return throwError(() => error);
            }
            return timer(3000);
          })
        )
      )
    );
  }
}
